
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Urbaniaonrentinmumbai() {



    const cardData =
    {
        keyword: 'Urbania on Rent in Mumbai',
        heading: 'S9 Travels: Urbania on Rent in Mumbai',
        headingDescription: 'S9 Travels offers Urbania on Rent in Mumbai, providing a spacious, comfortable, and reliable travel experience for group trips, corporate travel, family outings, and more. Our well-maintained Tata Urbania vehicles come with modern features, ample legroom, and professional drivers to ensure a smooth and hassle-free journey. Enjoy affordable pricing, on-time service, and 24/7 availability for your travel needs. Book your Urbania on Rent in Mumbai with S9 Travels for a convenient and comfortable ride!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "An iconic landmark of Mumbai, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary to India. Overlooking the Arabian Sea, it is a popular tourist attraction and a starting point for ferry rides to Elephanta Caves."
    },
    {
      "title": "Marine Drive",
      "description": "A picturesque boulevard along the Arabian Sea, Marine Drive is known as the 'Queen’s Necklace' due to its stunning night view. It is a perfect spot for a leisurely stroll, enjoying the sunset, or experiencing Mumbai’s lively atmosphere."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these UNESCO World Heritage caves house ancient rock-cut temples dedicated to Lord Shiva. The stunning sculptures and historical significance make it a must-visit for history enthusiasts."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
      "description": "A UNESCO World Heritage Site, this historic railway station is an architectural marvel blending Victorian Gothic and Indian elements. It is one of the busiest railway stations in India and a symbol of Mumbai’s colonial past."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of the most famous Hindu temples in Mumbai, the Siddhivinayak Temple is dedicated to Lord Ganesha. Devotees from all over the country visit this temple to seek blessings, including celebrities and politicians."
    },
    {
      "title": "Juhu Beach",
      "description": "A popular beach in Mumbai, Juhu Beach is known for its street food stalls serving Mumbai’s famous chaats and pav bhaji. It is a great place for an evening walk, enjoying the sea breeze, and watching the sunset."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Located on an islet in the Arabian Sea, Haji Ali Dargah is a revered shrine visited by people of all faiths. The Indo-Islamic architecture and the spiritual aura make it a unique place to visit in Mumbai."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for shoppers and food lovers, Colaba Causeway is known for its street shopping, trendy cafes, and historic charm. It is a great place to explore Mumbai’s vibrant culture and pick up souvenirs."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A lush green oasis in the heart of Mumbai, this national park is home to diverse wildlife, ancient Kanheri Caves, and nature trails. It is a perfect getaway for nature and adventure lovers."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An engineering marvel, the Bandra-Worli Sea Link is a cable-stayed bridge that connects South Mumbai to the western suburbs. The breathtaking view of the Mumbai skyline from the bridge is a sight to behold."
    }
],

"services": [
  {
    "name": "Urbania on Rent in Mumbai",
    "description": "Rent a spacious and comfortable Urbania car in Mumbai with S9 Travels. Whether you're traveling for leisure, business, or special events, our Urbania rental service provides the perfect combination of luxury and convenience. Enjoy a smooth and enjoyable journey with flexible rental options tailored to your travel needs."
  },
  {
    "name": "Rent Urbania Car in Mumbai",
    "description": "Book an Urbania car for your travel in Mumbai with S9 Travels. Our Urbania rental service offers a comfortable and spacious ride, perfect for both short and long trips. Whether you're exploring the city or need transportation for an event, our Urbania cars ensure a smooth and stylish journey."
  },
  {
    "name": "Affordable Urbania Rental Service in Mumbai",
    "description": "Looking for an affordable Urbania rental in Mumbai? S9 Travels offers budget-friendly rates for our premium Urbania cars, without compromising on comfort and service quality. Whether you need a one-way trip or a round trip, our rental service offers great value for money with no hidden fees."
  },
  {
    "name": "Book Urbania Car for Travel in Mumbai",
    "description": "Booking an Urbania car for your travel in Mumbai is easy with S9 Travels. Whether it's a quick business trip or a leisurely exploration of the city, our Urbania rentals provide the perfect balance of space, comfort, and reliability. Enjoy a pleasant journey with a professional chauffeur at the wheel."
  },
  {
    "name": "Urbania Hire for Group Travel in Mumbai",
    "description": "Planning a group trip in Mumbai? Hire an Urbania car from S9 Travels to accommodate your group comfortably. With plenty of space and modern amenities, our Urbania cars are ideal for family outings, corporate events, or group tours, ensuring everyone travels together in comfort and style."
  },
  {
    "name": "Urbania Car Rental for Mumbai Tours",
    "description": "Explore the top attractions of Mumbai with an Urbania car rental from S9 Travels. Our spacious and comfortable vehicles are perfect for sightseeing, offering a relaxed ride while you visit landmarks like Gateway of India, Marine Drive, and more. Let us handle the driving while you enjoy the city."
  },
  {
    "name": "Luxury Urbania Rental in Mumbai",
    "description": "Indulge in a luxurious ride with an Urbania rental in Mumbai from S9 Travels. Our luxury Urbania cars come equipped with premium features and amenities, offering the highest level of comfort and style. Perfect for any occasion, enjoy a lavish ride with professional chauffeurs ensuring your experience is seamless and enjoyable."
  },
  {
    "name": "Urbania for Outstation Travel from Mumbai",
    "description": "Travel comfortably on an outstation trip from Mumbai with an Urbania car rental from S9 Travels. Our Urbania cars offer ample space and comfort for long-distance journeys, making them the perfect choice for family vacations, corporate trips, or weekend getaways. Enjoy a smooth and safe ride to your destination."
  },
  {
    "name": "Urbania Rent for Special Occasions in Mumbai",
    "description": "Make your special occasions even more memorable with an Urbania car rental in Mumbai. Whether it's a wedding, anniversary, or any other celebration, our luxury Urbania cars provide the ideal transportation for your big day. With professional chauffeurs and top-notch amenities, enjoy an unforgettable experience."
  }
],

"tableData": [
  ["Urbania on Rent in Mumbai", "Rent Urbania Car in Mumbai"],
  ["Affordable Urbania Rental Service in Mumbai", "Book Urbania Car for Travel in Mumbai"],
  ["Urbania Hire for Group Travel in Mumbai", "Urbania Car Rental for Mumbai Tours"],
  ["Luxury Urbania Rental in Mumbai", "Urbania for Outstation Travel from Mumbai"],
  ["Urbania Rent for Special Occasions in Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Ride",
    "WhyChoosedescription": "S9 Travels offers Force Urbania on rent in Mumbai, providing a spacious and luxurious ride for group travel. With seating capacities ranging from 9 to 17 seats, it ensures a comfortable journey for large groups, business trips, family vacations, or special events."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of punctuality. Our Urbania rental service in Mumbai ensures timely pick-ups and drop-offs, allowing you to travel without any delays. Whether for business, leisure, or special occasions, we guarantee dependable service."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are well-acquainted with the best routes and road conditions in Mumbai and beyond. They prioritize your safety, comfort, and convenience, ensuring a smooth and pleasant ride in the Force Urbania."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and affordable pricing for Force Urbania rentals in Mumbai. We provide a clear, transparent pricing structure with no hidden charges, allowing you to plan your travel budget efficiently."
  },
  {
    "WhyChooseheading": "Safety and Comfort During Your Journey",
    "WhyChoosedescription": "Your safety is our priority. All our Force Urbania vehicles come equipped with modern safety features such as GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Urbania rental in Mumbai. Whether you need the vehicle for an early morning departure or a late-night return, we are available to accommodate your travel needs."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Urbania Trip",
    "WhyChoosedescription": "Every trip is unique, and we understand your needs. Whether you require additional stops, specific destinations, or special arrangements, we offer customizable itineraries to make your journey in the Urbania more enjoyable and tailored to your preferences."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Force Urbania rental in Mumbai with S9 Travels is quick and hassle-free. You can easily book online through our website or mobile app, or contact our customer service team for personalized assistance to make the booking process as smooth as possible."
  }
]













    }

    const faqData = [
        [
          {
            question: 'How can I rent an Urbania in Mumbai?',
            answer: 'Renting an Urbania in Mumbai is simple! You can book your rental through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a hassle-free rental experience.',
          },
          {
            question: 'What types of Urbania vehicles are available for rent in Mumbai?',
            answer: 'We offer different variants of Urbania vehicles for rent in Mumbai, including premium, standard, and luxury models. Choose the one that best suits your travel needs and group size.',
          },
          {
            question: 'How long can I rent an Urbania in Mumbai?',
            answer: 'You can rent an Urbania in Mumbai for as long as you need! Whether it’s a few hours, a day, or longer, we provide flexible rental options to suit your schedule and requirements.',
          },
          {
            question: 'Do you provide drivers with the Urbania rental in Mumbai?',
            answer: 'Yes, we provide experienced and professional drivers with all Urbania rentals in Mumbai. Our drivers are familiar with the city routes and will ensure your comfort and safety during the journey.',
          },
          {
            question: 'How much does it cost to rent an Urbania in Mumbai?',
            answer: 'The rental cost depends on the model of Urbania you choose, the duration of your rental, and any additional services. Contact us for a customized quote based on your specific needs.',
          },
          {
            question: 'Is there a security deposit required to rent an Urbania in Mumbai?',
            answer: 'Yes, a refundable security deposit is required when renting an Urbania. The amount will vary depending on the model of the vehicle and rental duration.',
          },
          {
            question: 'Can I pick up the Urbania from a specific location in Mumbai?',
            answer: 'Yes, we offer flexible pick-up options. You can pick up your rented Urbania from a location of your choice in Mumbai, including your home, office, or any other convenient spot.',
          },
          {
            question: 'Can I extend my Urbania rental if I need more time?',
            answer: 'Yes, you can extend your Urbania rental in Mumbai based on availability. Simply contact our customer service team, and they will assist you with the extension.',
          },
          {
            question: 'Do you offer delivery and pick-up services for Urbania rentals in Mumbai?',
            answer: 'Yes, we offer delivery and pick-up services for your Urbania rental. We will ensure that the vehicle is delivered to your location and picked up at the end of your rental period.',
          },
          {
            question: 'Why should I choose S9 Travels for renting an Urbania in Mumbai?',
            answer: 'S9 Travels offers reliable, affordable, and comfortable Urbania rentals in Mumbai. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a smooth and enjoyable rental experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I rented an Urbania from S9 Travels for a trip around Mumbai, and the experience was fantastic. The vehicle was clean, spacious, and comfortable, and the driver was professional and friendly. The booking process was seamless, and the entire experience exceeded our expectations. I highly recommend S9 Travels for Urbania rentals in Mumbai!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We rented an Urbania for a family trip in Mumbai, and it was an amazing experience. The vehicle was comfortable, well-maintained, and spacious enough for our group. The driver was friendly and knowledgeable about the city. We had a smooth and pleasant journey, and we will definitely choose S9 Travels again for future rentals in Mumbai!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Urbania on Rent in Mumbai",
        "description": "Book affordable and luxury Urbania car rental services in Mumbai. Whether for group travel, special occasions, outstation trips, or tours, S9 Travels offers reliable Urbania rental service in Mumbai for all your transportation needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
  


    return (
        <div>
            <Helmet>
        <title>Urbania on Rent in Mumbai | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Urbania on rent in Mumbai for group travel, tours, special occasions, or outstation trips. Affordable, luxury Urbania rental services for comfortable and stylish travel with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinmumbai;